module.exports = __webpack_public_path__ + "img/amazon_linux_logo-dev.3096c6f3.jpg";